import { Text } from '@doda/io-react/common';

/**
 * SubTitleコンポーネントのプロパティ
 */
interface SubTitleProps {
  /** 表示するテキスト */
  text: string;
}

/**
 * サブタイトルコンポーネント
 * @param {SubTitleProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} SubTitleのJSX要素
 */
export const SubTitle = ({ text }: SubTitleProps) => {
  return (
    <Text as="p" size="14--articlePC" color="black_pc" weight="normal">
      {text}
    </Text>
  );
};
